module.exports = __webpack_public_path__ + "media/9_BL.415e70f9.mp3";